module.exports = __webpack_public_path__ + "static/travisPose.adaa2641.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/travisPose.png
// module id = 271
// module chunks = 35783957827783 206603627034982